import FullInfoField from 'components/FullInfoField/FullInfoField';
import { IMccCard } from 'types';
import React from 'react';
import style from './MccCard.module.scss';

interface IMccCardProps {
	cardInfo: IMccCard | undefined;
}

const MccCard: React.FC<IMccCardProps> = ({ cardInfo }) => {
	return (
		<div className={style.container}>
			<FullInfoField label="cardBrandLabel" value={cardInfo?.brand} />
			<FullInfoField label="mccLabel" value={cardInfo?.mcc} />
		</div>
	);
};

export default MccCard;
